import { createPublicTypedEventPage } from "../typedEvents/PublicTypedEventPage";

// The shared implementation, typed 'clinic'. Change behavior in
// typedEvents/PublicTypedEventPage.tsx, once, for every type.
export default createPublicTypedEventPage("clinic");
